import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { HitStatusBulkStore } from './hit-status-bulk-store.interface';
export class hitStatusBulkStoreService {
   async gethitStatusBulkStores() {
      throw Error('Method not implemented');
   }

   async gethitStatusBulkStore() {
      throw Error('Method not implemented');
   }

   async posthitStatusBulkStore() {
      throw Error('Method not implemented');
   }

   async puthitStatusBulkStore() {
      throw Error('Method not implemented');
   }

   async deletehitStatusBulkStore() {
      throw Error('Method not implemented');
   }

   async bulkUpdateStatuses(hitStatusBulkStore: HitStatusBulkStore) {
      const response = await http.post<ApiResource<HitStatusBulkStore>>('/hit-statuses/bulk-store', hitStatusBulkStore);
      return response.data.data;
   }
}
